import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import EnrollBtn from 'src/components/Event/EnrollBtn';
import { Mixpanel } from '../../Mixpanel';
import Blur from 'react-blur';

class HackItem extends Component {
  constructor() {
    super()
    this.state = {
      waitingForEnroll: false,
      enrolled: false,
      enrolledUsers: 0,
    };
  }

  tags = (tags) => {
    if (tags.length > 1) {
      return (tags[0] + ' +' + (tags.length-1))
    }
    return tags[0]
  }

  render() {
    const { hackathon, history } = this.props;
    return (
      <div className='hackathon-item' onClick={() => {Mixpanel.track('Hackathons', {'Open hackathon' : hackathon.id}); hackathon.short ? window.open(hackathon.link, "_blank") : history.push(`/event/${hackathon.id}`)}}>
        <div className='hackathon-preview' data-id={hackathon.id}>
          <Blur className='blur' img={hackathon.picture} blurRadius={50}>
          </Blur>
          <img src={hackathon.picture} alt="" />
          <div className={hackathon.place.country !== 'Нет информации' ? 'hackathon-short-info hackathon-place':'none'}>{hackathon.place.country}, {hackathon.place.city}</div>
          <div className={this.tags(hackathon.tags) !== "" ? 'hackathon-short-info hackathon-org' : 'none'}>{this.tags(hackathon.tags)}</div>
          <EnrollBtn hackathon={hackathon} parent='Hackathons'></EnrollBtn>
          <div className='hackathon-short-info hackathon-dateto'>
            <span role='img' aria-label="emoji">🔥 </span>{hackathon.start_date.fromNow()}
          </div>
        </div>
        <div className='hackathon-text-info-wrapper'>
          <div className='text-info text-info_date'>
            {hackathon.start_date.locale('ru').format("D MMMM")} — {hackathon.end_date.locale('ru').format("D MMMM YYYY")} 
          </div>
          <div className='text-info text-info_name'>{hackathon.name}</div>
          <div className='text-info text-info_discription'>{hackathon.description}</div>
          <div className='text-info text-info_adress'>{hackathon.place_additional}</div>
        </div>
      </div>
    );
  }
}

HackItem.propTypes = {
  hackathon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    picture: PropTypes.string.isRequired,
    place: PropTypes.shape({
      country: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
    }),
    tags: PropTypes.array.isRequired,
    start_date: PropTypes.object.isRequired,
    end_date: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    place_additional: PropTypes.string,
    link: PropTypes.string.isRequired,
    short: PropTypes.bool,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
}

export default withRouter(HackItem);


// WEBPACK FOOTER //
// ./src/components/Hackathons/HacksList/HackItem.js